import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import pulsechain from "../../../assets/images/pulsechain.png"
import pulsex from "../../../assets/images/pulsex.png"
import aboutimg from "../../../assets/images/aboutimg.png"

const Anoutimg = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
`;
const GridHEading = styled(Grid)`
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: center;
`;

const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-left: 10px;
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "100PX")};

 }
`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper p="2rem 0 0" p799="0" p599="0" id="features">
        <Container maxWidth="xl">
          <GridHEading container spacing={3}>

            <GridImage item xs={12} md={6}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >

             <Anoutimg src={aboutimg}/>
            </GridImage>

            <Grid item xs={12} md={6} data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="200"
              data-aos-duration="500"
              data-aos-offset="0">
              <SectionHeading
                p="30px 0"
                m="0"
                align="left"
                fs="70px"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >About
              </SectionHeading>
              <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
                Pulse Pepe is the ultimate memecoin on the innovative Pulse Chain and designed to reignite the passion and creativity of the meme community.

                <br />
                <br />
                With no presale, zero taxes, burnt LP all with a renounced contract to boot, $PEPE is a coin for the people, fueled by pure memetic power.
                <br />
                <br />
                Say goodbye to endless derivative coins and let Pulse Pepe show you the way to a new era of memecoins that puts the most recognizable meme in the world at the center of the action.
              </P>
              <div style={{ display: "flex", alignItems: "center" }}>
              <SectionSmallHeading p="20px 0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-duration="400"
                data-aos-offset="0">View us:</SectionSmallHeading>
              <a href=""  target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1100"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={pulsechain} />
              </a>
              <a href="" target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1200"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={pulsex} />
              </a>
            </div>
            </Grid>

          </GridHEading>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
